export function useImageCropUpload(onConfirmed: (file: File) => void) {
  const cropSrc = ref<string | null>(null)
  const pendingFileName = ref<string>('')

  const handleFileSelected = (event: Event) => {
    const input = event.target as HTMLInputElement
    const file = input.files?.[0]
    if (!file) return

    // Canvas cropping freezes animated images (GIF, WebP) to a single frame,
    // so skip the crop step to preserve the animation.
    if (file.type === 'image/gif' || file.type === 'image/webp') {
      input.value = ''
      onConfirmed(file)
      return
    }

    pendingFileName.value = file.name
    const reader = new FileReader()
    reader.onload = (e) => {
      if (e.target?.result) cropSrc.value = e.target.result as string
    }
    reader.readAsDataURL(file)
    input.value = ''
  }

  const onCropConfirm = (blob: Blob) => {
    const name = pendingFileName.value || 'image.jpg'
    cropSrc.value = null
    pendingFileName.value = ''
    onConfirmed(new File([blob], name, { type: blob.type }))
  }

  const onCropCancel = () => {
    cropSrc.value = null
    pendingFileName.value = ''
  }

  return { cropSrc, handleFileSelected, onCropConfirm, onCropCancel }
}
